// Import model
import { SfSection } from '../models/SfSection';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for SfSection - handles JSON serialization and deserialization with type validation
 */
export class SfSectionSerializer {
  /**
   * Deserializes a JSON string into a SfSection instance
   */
  static deserialize(json: string): SfSection {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a SfSection instance
   */
  static fromObject(obj: any): SfSection {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to SfSection');
    }


    const instance: SfSection = {
      externalId: obj['externalId'] as string | undefined,
      proposalExternalId: obj['proposalExternalId'] as string | undefined,
      proposalExternalIdName: obj['proposalExternalId|Name'] as string | undefined,
      area: obj['area'] as number | undefined,
      name: obj['name'] as string | undefined,
      perimeter: obj['perimeter'] as number | undefined,
      totalBeforeTax: obj['totalBeforeTax'] as number | undefined,
      totalCost: obj['totalCost'] as number | undefined,
      totalPrice: obj['totalPrice'] as number | undefined,
      totalTax: obj['totalTax'] as number | undefined,
      wasteFactor: obj['wasteFactor'] as number | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of SfSection instances
   */
  static deserializeArray(json: string): SfSection[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a SfSection instance to a JSON string
   */
  static serialize(instance: SfSection): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a SfSection instance to a plain object
   */
  static toObject(instance: SfSection): any {
    return {
      'externalId': instance.externalId,
      'proposalExternalId': instance.proposalExternalId,
      'proposalExternalId|Name': instance.proposalExternalIdName,
      'area': instance.area,
      'name': instance.name,
      'perimeter': instance.perimeter,
      'totalBeforeTax': instance.totalBeforeTax,
      'totalCost': instance.totalCost,
      'totalPrice': instance.totalPrice,
      'totalTax': instance.totalTax,
      'wasteFactor': instance.wasteFactor,
    };
  }

  /**
   * Serializes an array of SfSection instances to a JSON string
   */
  static serializeArray(instances: SfSection[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
